<ng-container >
    <div [class.hidden]="!show">
    <div class="loading" *ngIf="show">
        <button class="btn btn-primary" type="button" disabled style="background-color: #fff;opacity: 1;">
          <!-- <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span class="sr-only">Loading...</span> -->
          <img src="assets/images/pin.gif" style="width: 40px">
        </button>
    </div>
</div>
</ng-container>
